import type { AnyObject } from 'syf-js-utilities/typings/AnyObject'
import type ResponseErrorItem from 'typings/ResponseErrorItem'
import isBusinessErrorData from './isBusinessErrorData'

/**
 * Gets the first item in the response body data that matches the passed code.
 * @param responseData (obj) an ErrorResponseData object with a businessErrors array
 * @param code (str) the error code to match against
 * @returns (obj) ResponseErrorItem or undefined if no match found
 */
function getBusinessErrorInResponse(
  responseData: AnyObject,
  signInErrorArray: string[]
): ResponseErrorItem | undefined {
  const isBusinessError = isBusinessErrorData(responseData)

  if (!responseData || !signInErrorArray || !isBusinessError) {
    return undefined
  }
  const { businessErrors } = responseData

  return businessErrors.find(({ code: currentCode }) => {
    return signInErrorArray.includes(currentCode)
  })
}

export default getBusinessErrorInResponse
